<template>
    <div class="hero" style="background-color: black;">
    <div class="bg-black" >

    <div v-if="forgotPassword" class="card body w-[95vw] md:w-[25vw]" style="padding: 4vh; display: flex;justify-content: center; height: 100vh;">
        <h1 class="text-3xl font-extrabold text-center tracking-wide text-white" style="font-weight: bolder; font-size: xx-large; justify-content: center; display: flex;">Forgot Password</h1>
        <fieldset class="fieldset">
            <label class="text-xl text-white font-bold">Email</label>
            <span></span>
            <input type="email" autocomplete="off" v-model="email" class="w-full px-4 py-2 bg-black text-xl text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition" placeholder="you@example.com" style="width: 100%; height: 3rem;" />                      
            <span></span>                   
            <div style="display: flex; justify-content: space-between;">
            <a class="text-md link underline text-white" @click="forgotPassword = false">Back to Login</a>
            </div>
            <span></span>
            <span></span>
            <button v-if="!loading" class="rounded-md text-xl text-black font-semibold" name = "paswordReset" @click="paswordReset" ref="paswordResetBtn" :style="['height: 2.75rem; width: 100%;', canEnableForgotPassword ? ' background-color: white;': ' background-color: gray;']" :disabled="!canEnableForgotPassword">Reset Password</button>
            <button v-if="loading" class="rounded-md text-xl text-black font-semibold" :style="['height: 2.75rem; width: 100%;', canEnable ? ' background-color: white;': ' background-color: gray;']" :disabled="!canEnable">
            <span class="loading loading-dots loading-xl"></span>
            </button>
        </fieldset>
        <div class="flex justify-center">
        <span class="text-sm font-semibold text-center" :class="['',isSuccess ? 'text-green-400': 'text-[#e62525]' ]">{{ error_message }}</span>   
        </div>
    </div>

    <div v-if="!forgotPassword" class="card body p-0 w-[95vw] md:w-[25vw]" style="padding: 4vh; display: flex;justify-content: center; height: 100vh;">
        <h1 class="text-3xl font-extrabold text-center tracking-wide text-white" style="font-weight: bolder; font-size: xx-large; justify-content: center; display: flex;">Login</h1>
        <fieldset class="fieldset">
            <label class="text-xl text-white font-bold">Email</label>
            <span></span>
            <input type="email" autocomplete="off" v-model="email" class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl"  placeholder="you@example.com" style="width: 100%; height: 3rem;" />
            <span></span>
            <label class="text-xl text-white font-bold" >Password</label>
            <span></span>
            
            <input class="w-full px-4 py-2 bg-black text-white border border-white/30 rounded-md focus:outline-none focus:ring-2 focus:ring-white transition text-xl" minlength="8" maxlength="30" :type="showPassword ? 'text' : 'password'" ref="passwordInput" v-model="password"  placeholder="••••••••" style="width: 100%; height: 3rem;">
            <span></span>       
            <span></span>
            <div style="display: flex; justify-content: space-between;">
            <a class="text-md link underline text-white" @click="forgotPassword = true">Forgot password? </a>
            <label class="text-md text-white" @click="togglePassword">{{ showPassword ? 'Hide Password' : 'Show Password' }}</label>
            </div>
            <span></span>            
            <button v-if="!loading" class="rounded-md text-xl text-black font-semibold" name = "login" @click="login" ref="loginBtn" :style="['height: 2.75rem; width: 100%;', canEnable ? ' background-color: white;': ' background-color: gray;']" :disabled="!canEnable">
            <span>Login</span>
            </button>
            <span></span>
            <span></span>
            <button v-if="!loading" class="rounded-md text-xl text-black font-semibold" name = "register" @click="register" ref="registerBtn" :style="['height: 2.75rem; width: 100%;', canEnable ? ' background-color: white;': ' background-color: gray;']" :disabled="!canEnable">
            <span >Register</span>
            </button>
            <button v-if="loading" class="rounded-md text-xl text-black font-semibold" :style="['height: 2.75rem; width: 100%;', canEnable ? ' background-color: white;': ' background-color: gray;']" :disabled="!canEnable">
            <span class="loading loading-dots loading-xl"></span>
            </button>
        </fieldset>
        <div class="flex justify-center">
        <span class="text-sm font-semibold text-center" :class="['',isSuccess ? 'text-green-400': 'text-[#e62525]' ]">{{ error_message }}</span>   
        </div>
    </div>
    </div>
    </div>  
</template>

<script>
import { apiCall, validEmail } from "../js/main"
import { jwtDecode } from "jwt-decode";

export default {
    data() {
    return { email: "", 
            password: "", 
            loading: false,
            loadingname: '',
            showPassword: false,
            forgotPassword: false,
            error_message: "",
            isSuccess: false
         }
    },
    methods: {
       togglePassword() {
        this.showPassword = !this.showPassword
        },
       async login(){

      if (this.password.length < 8){
        this.error_message =  "Password must have alteast 8 characters"
        }
        else if (this.password.length > 30){
            this.error_message =  "Password must have max 30 characters"
        }
        else if (this.password.includes(" ")){
            this.error_message =  "Password must not have whitespace"
        } 
        else {
        const input = this.$refs.loginBtn;
        input.disabled = true
        this.loading = true
        this.loadingname = 'Logging In'
            
        var data = await apiCall("/user/login", "POST", 
                    {email: this.email,
                    password: this.password})
        
        if (data.success) {
            const decodedToken = jwtDecode(data.data.access_token);
            localStorage["token"] = data.data.access_token
            localStorage["id"] = decodedToken.sub

            this.$router.push('/dashboard'); 
        }

        else{
            this.isSuccess = false
            this.error_message = data.error_message
            input.disabled = false
        }
        
        this.loading = false

        }},
        async register(){
        const input = this.$refs.registerBtn;
        input.disabled = true
        this.loading = true
        this.loadingname = 'Registering User'

        var data = await apiCall("/user/register", "POST", 
                    {email: this.email,
                    password: this.password})

        if (data.success) {
            this.isSuccess = true
            this.error_message = "Verification Mail sent"
        }

        else{
            this.isSuccess = false
            this.error_message = data.error_message
            input.disabled = false
        }
        this.loading = false

        },
        async paswordReset(){
        const input = this.$refs.paswordResetBtn;
        input.disabled = true
        this.loading = true
        this.loadingname = 'Resetting Password'

        var data = await apiCall("/user/reset-password", "POST", 
                    {email: this.email,
                    password: "password"})

        if (data.success) {
            this.forgotPassword = false
            this.isSuccess = true
            this.error_message = "Password  Reset Mail sent"
        }

        else{
            this.isSuccess = false
            this.error_message = data.error_message
            input.disabled = false
        }
        this.loading = false

        }
    },
    computed: {
        canEnable() {
            return validEmail(this.email) && this.password.length >= 8;
        }
        ,
        canEnableForgotPassword() {
            return validEmail(this.email);
        }
        },
    beforeMount(){
        const token = localStorage["token"]

        if (token !== "null" && token !== undefined && token !== 'undefined'){
            this.$router.push('/dashboard'); 
        }
    } 

}
</script>

<style scoped>

.input, button {
font-size: 1.5rem
}

label, a {
font-size: 1rem
}

</style>